export function getDevicePixelRatio() {
  return Math.max(Math.ceil(window.devicePixelRatio), 2);
}